import type { Filters } from '@/types/table';
import { filterTypes } from '@/types/table';

const TABLE_FILTERS: Filters[] = [
  {
    selector: 'fileId',
    value: ''
  },
  {
    selector: 'fileName',
    value: ''
  },
  {
    selector: 'uploadedDate',
    value: ''
  },
  {
    selector: 'state',
    value: ''
  },
  {
    selector: 'uploadedBy',
    value: '',
    criteria: filterTypes.EQUALS
  }
];

export default TABLE_FILTERS;
